import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'form-complete',
  templateUrl: './form-complete.component.html',
  styleUrls: ['./form-complete.component.scss']
})
export class FormCompleteComponent implements OnInit {

  constructor(private toastr: ToastrService) {}


  email: string = '';
  firstName: string = '';
  lastName: string = '';
  company: string = '';

  ngOnInit(): void {
  }

  onSubmit()
  {
     this.toastr.success('Form was submitted and will appear in ZoomInfo!', 'Success!');
    (window as any)._zi_fc.fcTriggerSubmit();
  }

}
